module.exports = "/packs/layout-background-icon-5f4713a2465a5cb61d04d691a9afb98e.svg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/packs/Shared/assets/images/layout-background-icon.svg
// module id = ./app/javascript/packs/Shared/assets/images/layout-background-icon.svg
// module chunks = 1